import { render, staticRenderFns } from "./DatosPacienteNinoHC.vue?vue&type=template&id=199c3552&scoped=true"
import script from "./DatosPacienteNinoHC.vue?vue&type=script&lang=js"
export * from "./DatosPacienteNinoHC.vue?vue&type=script&lang=js"
import style0 from "./DatosPacienteNinoHC.vue?vue&type=style&index=0&id=199c3552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199c3552",
  null
  
)

export default component.exports